import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'
import {
  ITeleportPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/TeleportPropertyTypeStrategy/types/ITeleportPropertyTypeInterfaces'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'

import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {IDatabaseGroupItem} from '@toolify/client/src/modules/databases/types/IDatabaseGroupItem'
import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'

export function useTeleportPropertyTypeStrategy() {

  const getSourcePropertyId = (property: IDatabasePropertyResponseInstance<ITeleportPropertyTypeInterfaces['options'], ITeleportPropertyTypeInterfaces['optionData'], unknown>) => {
    return property.optionData?.sourcePropertyId ?? property.id
  }

  const getIsActive = (value: ITeleportPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance, item: IDatabaseItemResponseInstance) => {
    const teleportOptions = property?.options as ITeleportPropertyTypeInterfaces['options']
    if (!teleportOptions) {
      return false
    }
    if (!teleportOptions?.relationPropertyId) {
      return false
    }
    return true
    // const relationValue = item.cellValues[teleportOptions.relationPropertyId]?.value as IRelationPropertyTypeInterfaces['fullValue'] //TODO no always all column values fetched so this wont work good
    // return relationValue?.count > 0
  }

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItem, showAllDatabaseGroups: boolean): IFilter => {
    const groupItemValue = (groupItem.value) as ITeleportPropertyTypeInterfaces['storedValue']
    if(groupItem.value === null) {
      return {
        type: FilterItemType.Group,
        operator: FilterGroupOperator.Or,
        items: [{
          type: FilterItemType.Property,
          id: group,
          operator: {
            type: FilterPropertyOperator.Equals,
            options: {
              isCaseSensitive: true,
            },
          },
          subProperty: null,
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: null,
          },
          isDisabled: false,
        }, {
          type: FilterItemType.Property,
          id: group,
          operator: {
            type: FilterPropertyOperator.Empty,
          },
          subProperty: null,
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: null,
          },
          isDisabled: false,
        }],
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.Equals,
        options: {
          isCaseSensitive: true,
        },
      },
      subProperty: null,
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: groupItemValue,
      },
      isDisabled: false,
    }
  }

  const getRestrictedEditReason = (): RestrictedEditReasonType => {
    return RestrictedEditReasonType.Teleport
  }

  return $$({
    getIsActive,
    getGroupFilter,
    getSourcePropertyId,
    getRestrictedEditReason,
  })
}
